<template>
	<div class="button-container">
		<label
			v-if="!isListView"
			class="button-label"
		>
			{{ $t('processingStatus') }}
		</label>
		<button @click="handleClick">
			<img
				:src="inventarioOficial ? imgOficial : imgNaoOficial"
				alt="Ícone"
				:style="iconStyle"
			/>
		</button>
	</div>
</template>

<script>
export default {
	name: 'OfficialProcessingIcon',
	props: {
		inventarioOficial: {
			type: Boolean,
			required: true,
		},
		isListView: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		return {
			imgOficial: require('@/assets/star-on.png'),
			imgNaoOficial: require('@/assets/star-off.png'),
		}
	},
	computed: {
		iconStyle() {
			return this.isListView
				? { width: '30px', height: '25px' } // Tamanho para lista
				: { width: '60px', height: '50px' } // Tamanho para visualização normal
		},
	},
	methods: {
		handleClick() {
			this.$emit('definirComoProcessamentoOficial')
		},
	},
}
</script>

<style scoped>
.button-container {
	display: inline-block;
	margin-top: 10px;
}
.button-label {
	display: block;
	margin-bottom: 10px;
}

label {
	margin-bottom: 5px;
	font-size: 13px;
}

button {
	background: none;
	border: none;
	cursor: pointer;
}

img {
	transition:
		width 0.3s,
		height 0.3s; /* Animação para suavizar a transição */
}
</style>
